import { Info, ExternalLink } from "lucide-react";
import { useI18n } from "../i18n/LanguageContext";
import { TICKET_LINKS } from "../data/mediaAssets";
import { useReveal } from "../hooks/useReveal";

const ImportantInfo = () => {
    const { t } = useI18n();
    const ref = useReveal();

    return (
        <section
            id="info"
            data-testid="info-section"
            className="bg-white py-24 md:py-32"
        >
            <div className="max-w-4xl mx-auto px-6 md:px-10">
                <div
                    ref={ref}
                    className="reveal relative bg-brand-ivory border border-brand-gold/40 p-8 md:p-14 text-center"
                >
                    <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-brand-gold p-3">
                        <Info className="w-5 h-5 text-brand-navy" />
                    </div>

                    <p className="font-sans text-brand-gold text-xs uppercase tracking-[0.5em] mb-4">
                        — {t.info.eyebrow}
                    </p>
                    <h2
                        data-testid="info-title"
                        className="font-serif text-brand-navy text-3xl md:text-4xl mb-6"
                    >
                        {t.info.title}
                    </h2>
                    <p className="font-sans text-neutral-700 leading-relaxed max-w-2xl mx-auto">
                        {t.info.body}
                    </p>

                    <div className="mt-10 pt-8 border-t border-brand-gold/30">
                        <p className="font-sans text-[11px] uppercase tracking-[0.35em] text-brand-navy/70 mb-6">
                            {t.info.links_title}
                        </p>
                        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-10">
                            <a
                                href={TICKET_LINKS.pena}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="ticket-link-pena"
                                className="group inline-flex items-center gap-2 font-serif text-brand-navy text-xl md:text-2xl border-b border-brand-navy/30 hover:border-brand-gold hover:text-brand-gold transition-colors pb-1"
                            >
                                {t.info.pena}
                                <ExternalLink className="w-4 h-4 opacity-70 group-hover:opacity-100" />
                            </a>
                            <a
                                href={TICKET_LINKS.regaleira}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="ticket-link-regaleira"
                                className="group inline-flex items-center gap-2 font-serif text-brand-navy text-xl md:text-2xl border-b border-brand-navy/30 hover:border-brand-gold hover:text-brand-gold transition-colors pb-1"
                            >
                                {t.info.regaleira}
                                <ExternalLink className="w-4 h-4 opacity-70 group-hover:opacity-100" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ImportantInfo;
